import { ThemeConfig } from 'antd'

const AntdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#31B59F',
    controlItemBgActive: '#EDF6FF',
    colorPrimaryBg: '#EDF6FF',
    colorPrimaryHover: '#EDF6FF',
    fontFamily: 'Avenir Next W01, Arial, Helvetica, sans-serif'
  },
  components: {
    Table: {
      rowHoverBg: '#EDF6FF',
      rowSelectedHoverBg: '#EDF6FF',
      bodySortBg: 'transparent'
    },
    DatePicker: {
      hoverBorderColor: '#31B59F',
      colorBgContainerDisabled: 'transparent',
      colorTextDisabled: '#AAABAD',
      colorTextPlaceholder: '#AAABAD'
    },
    Checkbox: {
      colorPrimaryHover: '#31B59F'
    },
    Tabs: {
      itemHoverColor: '#31B59F'
    },
    Button: {
      colorPrimaryHover: '#2b9381'
    }
  }
}

export default AntdTheme
